var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ExpedienteService } from '../../services/expediente.service';
import { Signer, SIGNER_STATUS } from '../../common/firmador/firma-helper.component';
import { Escrito } from '../../model/escrito';
import { CommonService } from '../../services/common.service';
var FirmarComponent = (function () {
    function FirmarComponent(_service, _comService, sanitizer) {
        this._service = _service;
        this._comService = _comService;
        this.sanitizer = sanitizer;
        this.PRESIGN = 1;
        this.SIGNING = 2;
        this.POSTSIGN = 3;
        this.onStatusChange = new EventEmitter(false);
        this.firmadorSelected = new EventEmitter(false);
        this.visible = false;
        this.aliases = [];
        this.cns = [];
        this.escrito = new Escrito();
        this.estado = this.PRESIGN;
        this.statusMessage = "";
        this.discert = true;
        this.firmador = "";
        this.mensajeCert = "Cargando Certificados, aguarde por favor";
    }
    FirmarComponent.prototype.open = function (filename, fileId, doc) {
        var _this = this;
        var that = this;
        that._comService.emitBlocking(false);
        this.signer = new Signer(fileId, doc);
        this.signer.onAliasOk.subscribe(function (event) {
            _this.aliases = _this.signer.aliases;
            _this.discert = false;
            _this.cns = _this.signer.commonNames;
            _this.mensajeCert = "Seleccione un Certificado";
        });
        this.signer.onSignOk.subscribe(function (event) { _this.save(); });
        this.signer.onError.subscribe(function (event) { _this.error(); });
        //this.escrito = esc;
        this.fileId = fileId;
        this.filename = filename;
        // this._service.getFile(btoa(fileId + "/" + filename)).subscribe(response => {
        //     this.previewEscrito = this.sanitizer.bypassSecurityTrustResourceUrl("data:application/pdf;base64," + response.data);
        //     setTimeout(() => this._comService.emitBlocking(false), 1000);
        // });
        this.statusMessage = "";
        this.estado = this.PRESIGN;
        this.visible = true;
    };
    FirmarComponent.prototype.reset = function () {
        this.aliases = [];
        this.selectedAlias = "";
    };
    FirmarComponent.prototype.firmar = function () {
        this.estado = this.SIGNING;
        //console.log("firmando con " + this.selectedAlias + " ...");
        //firma y deja los archivos de firma junto con el documento en folder
        this.firmadorSelected.emit(this.firmador);
        this.signer.doSign(this.selectedAlias);
    };
    FirmarComponent.prototype.onChangeSelectAliases = function (selected) {
        var index = this.aliases.indexOf(selected);
        //console.log("firmante " + this.cns[index]);
        this.firmador = this.cns[index];
        this.selectedAlias = selected;
    };
    FirmarComponent.prototype.save = function () {
        // this.escrito.usuCodigo = KeycloakService.getLoggedUser();
        // this._service.saveSignatures(this.fileId, this.escrito).subscribe((response) => {
        //     if (JSON.stringify(response).indexOf("error") > -1) {
        //         this.onStatusChange.emit(SIGNER_STATUS.ERROR.code);
        //         this.statusMessage = "No se pudo guardar el escrito y su firma. Por favor, reintente la operación. Gracias";
        //     } else {
        //         this.statusMessage = "Escrito firmado y guardado.";
        //         this.onStatusChange.emit(SIGNER_STATUS.SIGNOK.code);
        //         this.finalize();
        //     }
        // }, (error: Response) => {
        //     var exc = ServiceException.parse(error.json());
        //     console.log(exc.description);
        //     this.statusMessage = "No se pudo guardar el escrito (" + exc.errorCode + "). Por favor, reintente la operación. Gracias";
        // });
        this.onStatusChange.emit(SIGNER_STATUS.SIGNOK.code);
        this.finalize();
        this.estado = this.POSTSIGN;
    };
    FirmarComponent.prototype.finalize = function () {
        if (this.visible && this.signer) {
            this.reset();
            this.visible = false;
            this.previewEscrito = null;
            if (this.signer) {
                this.signer.close();
            }
            this.signer.finalize();
            this.signer = null;
            this.statusMessage = "";
            this.estado = this.PRESIGN;
            this.onStatusChange.emit(SIGNER_STATUS.CLOSED.code);
        }
    };
    FirmarComponent.prototype.error = function () {
        console.warn("WARNING: " + this.signer.getStatus().message);
        if (this.signer.getStatus().message.toUpperCase().indexOf("CKR_FUNCTION_CANCELED") > -1) {
            // ingreso de pin cancelado
            this.finalize();
        }
    };
    FirmarComponent.prototype.ngOnDestroy = function () {
        // this.finalize();
    };
    return FirmarComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FirmarComponent.prototype, "onStatusChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], FirmarComponent.prototype, "firmadorSelected", void 0);
FirmarComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'firmar',
        templateUrl: 'firmar.component.html',
    }),
    __metadata("design:paramtypes", [ExpedienteService, CommonService,
        DomSanitizer])
], FirmarComponent);
export { FirmarComponent };
//# sourceMappingURL=firmar.component.js.map